import { render, staticRenderFns } from "./Sushe.vue?vue&type=template&id=2c543e9a&scoped=true&"
import script from "./Sushe.vue?vue&type=script&lang=js&"
export * from "./Sushe.vue?vue&type=script&lang=js&"
import style0 from "./Sushe.vue?vue&type=style&index=0&id=2c543e9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c543e9a",
  null
  
)

export default component.exports